import React from 'react';

import { Box } from '@mui/material';

import LoadingStepIcon from './LoadingStepIcon';
import LoadingStepDelimiter from './LoadingStepDelimiter';

import { ILoadingProgressTutorial } from './interfaces';

import { useStyles } from './styles';

const LoadingProgressTutorial = ({
  secondStepLoading,
  secondStepCompleted,
  thirdStepLoading,
  thirdStepCompleted,
  forthStepLoading,
  forthStepCompleted,
}: ILoadingProgressTutorial) => {
  const classes = useStyles();

  return (
    <Box sx={classes.root}>
      <LoadingStepIcon loading={false} completed={true} />
      <LoadingStepDelimiter isCompleted />
      <LoadingStepIcon
        loading={secondStepLoading}
        completed={secondStepCompleted}
        step={2}
      />
      <LoadingStepDelimiter isCompleted={secondStepCompleted} />
      <LoadingStepIcon
        loading={thirdStepLoading}
        completed={thirdStepCompleted}
        step={3}
      />
      <LoadingStepDelimiter isCompleted={thirdStepCompleted} />
      <LoadingStepIcon
        loading={forthStepLoading}
        completed={forthStepCompleted}
        step={4}
      />
    </Box>
  );
};

export default LoadingProgressTutorial;
